import ChevronRight from '@material-ui/icons/ChevronRight'
import React from 'react'
import { Box, Paper, Space, Typography } from 'webbook-airways'

export default function DescriptionBox({
  minHeight = 240,
  subtitle,
  icon: Icon,
  title,
  children,
  onClick
}) {
  return (
    <Paper minHeight={minHeight} style={{ padding: 24 }} onClick={onClick}>
      <Typography variant="subtitle1" style={{ marginBottom: -5 }}>
        {subtitle}
      </Typography>
      <Box vAlign="center">
        {Icon && <Icon height={24} width={24} style={{ marginRight: 20 }} />}
        <Typography variant="h5" style={{ fontWeight: 500 }}>
          {title}
        </Typography>
      </Box>
      <Space size={15} />
      {children}
      {onClick && (
        <ChevronRight
          style={{
            position: 'absolute',
            right: 10,
            bottom: 15,
            fontSize: 42,
            color: 'rgba(0,0,0,0.25)'
          }}
        />
      )}
    </Paper>
  )
}
